import React, { useEffect } from 'react';
import './MusicPlayerTooltip.css';

interface MusicPlayerTooltipProps {
  position: { x: number; y: number };
  onDismiss: () => void;
  onClick: () => void;
}

const MusicPlayerTooltip: React.FC<MusicPlayerTooltipProps> = ({
  position,
  onDismiss,
  onClick
}) => {
  useEffect(() => {
    // Auto-dismiss after 4 seconds
    const timer = setTimeout(() => {
      onDismiss();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  const handleClick = () => {
    onClick();
    onDismiss();
  };

  console.log('Tooltip rendering with position:', position);

  return (
    <div
      className="music-player-tooltip"
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
      onClick={handleClick}
    >
      control music by tapping here!
    </div>
  );
};

export default MusicPlayerTooltip;
